module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/00730b4c9ce1009bf4028f722f77475b.png";